import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { PerformanceDatapoint } from 'owa-analytics';
import {
    lazyIsCollabSpaceExplicitlyDisabled,
    lazyHasFluidLinkFailed,
    lazyGetCreationSource,
} from 'owa-calendar-collaborative-space';

export async function logCollabSpaceInfo(
    event: CalendarEvent,
    datapoint: PerformanceDatapoint,
    viewStateId: string
) {
    if (event.CollabSpace?.shareLinkInfo?.url?.length > 0) {
        const creationSource = await lazyGetCreationSource.importAndExecute(viewStateId);
        datapoint.addCustomData({
            HasCollabSpace: true,
            CollabAllowed: event.CollabSpace.enabled,
            CollabSpaceCreationSource: creationSource,
        });
    } else {
        const hasFluidLinkFailed = await lazyHasFluidLinkFailed.importAndExecute(viewStateId);
        datapoint.addCustomData({
            HasCollabSpace: false,
            CollabAllowed: false,
            CollabSpaceCreationFailed: hasFluidLinkFailed,
        });
    }
    const isCollabSpaceExplicitlyDisabled = await lazyIsCollabSpaceExplicitlyDisabled.importAndExecute(
        viewStateId
    );
    datapoint.addCustomData({
        IsCollabSpaceExplicitlyDisabled: isCollabSpaceExplicitlyDisabled,
    });
}
